import React, { createRef } from 'react';
import { IonSegment, IonSegmentButton, IonSearchbar, IonLoading, IonAlert, IonButton, IonChip, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonActionSheet, IonInput, IonButtons, IonBackButton, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonToggle } from '@ionic/react';
import '../styles/Studyset.scss';
import '../styles/Flashcard.scss';
import FlashcardEditModal from './FlashcardEditModal';
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import Utilities from '../Utilities';
import TagEditorModal from './TagEditorModal';
import Flashcard from './Flashcard';
import ExportImportModal from './ExportImportModal';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import HelpOverlay, { ArrowComponent } from './HelpOverlay';
import Drawer from '@material-ui/core/SwipeableDrawer';

import NotificationsImg from '../images/notifications.png';
import ShareImg from '../images/share.png';
import QuizImg from '../images/quiz.png';
import FlashcardsImg from '../images/flashcards.png';

import { book, checkmarkDoneCircle, ellipsisHorizontal, checkmark, closeCircle, create, caretDownOutline, checkmarkCircle, headset, star, pricetag, close, volumeHigh, trash, more, add, albums, wallet, bulb, gitMerge, school, barbell, cloudDownload, cloudUpload, notificationsCircle, sync, trendingUp, image, playCircle, caretUpCircle, enter, exit, arrowRedo, arrowUndo, addCircle, print, download, caretDown, caretUp, informationCircleSharp, lockClosed, people, linkSharp, share, logoFacebook, logoInstagram, logoTwitch, logoTwitter, logoReddit, shareSharp, imageOutline } from 'ionicons/icons'

import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';
import PrintingModal from './PrintingModal';
import Server from '../Server';
import ReviewModal from './ReviewModal';

import Avatar from "boring-avatars";

import { Clipboard } from '@capacitor/clipboard';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Share } from '@capacitor/share';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

const CARDS_PER_PAGE = 25;

class Studyset extends React.Component {

    constructor(props) {
        super(props);
        this.pageRef = createRef();
        this.isLoadingMore = false;
        this.currentlyEditingId = null;
        this.listRef = createRef();
        this.studysetNameRef = createRef();
        this.state = {
            termFlag: null,
            definitionFlag: null,
            details: null,
            cards: null,
            visibleCards: [],
            hasChanged: false,
            action: "view",
            termPronouncation: false,
            definitionPronouncation: false,
            tags: [],
            currentlyEditedTag: null,
            currentFilter: "all",
            currentFilterName: "All Term",
            deleteSetConfirmationAlert: false,
            deleteCardConfirmationAlert: false,
            toBeDeletedCardId: null,
            limitExceededAlert: false,
            filterSelectorSheet: false,
            exportImportModal: null,
            notEnoughAlert: false,
            fullscreenLoading: true,
            currentPage: 0,
            filters: [],
            activeFilters: [],
            keywords: "",

            openCardI: null,
            openCardNew: false,
            printingModal: false,

            sortBy: "createdAt",
            sortOrder: "DESC",
            showGuide: !localStorage.getItem("help-overlay-hidden-studyset-modal") && window.location.href.indexOf("justcreated") === -1 && window.location.href.indexOf("/set/") === -1,
            selectPracticeType: null,
            showShareModal: null,
            reviewModal: null,
            allowUninitedPractice: false,
            pendingCardShareUpdates: 0,

            nonBlockingLoading: null
        }
    }

    async cacheFullsizedImages(silent) {
        console.log("%%%% cacheFullsizedImages");
        let images = [];

        for (let i = 0; i < this.state.cards.length; i++) {
            for (let j = 0; j < this.state.cards[i].image.length; j++) {
                const image = this.state.cards[i].image[j];
                const fileName = image.split("/")[5].split("?")[0];
                let hash = "image-" + (fileName.replace("image-image-", "").replace("image-", "").replace("thumb-", ""));
                // NOt cached, and caching enabled
                if (window.cachedImages.indexOf(hash) === -1 && window.settings.imgOfflineSets.indexOf(this.state.details.id) !== -1) {
                    images.push({
                        link: image,
                        cardId: this.state.cards[i].id
                    })

                    const thumbnailImage = this.state.cards[i].customText1[j];
                    if (thumbnailImage && !thumbnailImage.startsWith("data:")) {
                        const fileNameThumbnailImage = thumbnailImage.split("/")[5].split("?")[0];
                        let hashThumbnailImage = "thumb-" + (fileNameThumbnailImage.replace("image-image-", "").replace("image-", "").replace("thumb-", ""));
                        if (window.cachedImages.indexOf(hashThumbnailImage) === -1) {
                            images.push({
                                link: thumbnailImage,
                                cardId: this.state.cards[i].id,
                                thumbnail: true
                            })
                        }
                    }
                // Cached, and cache not enabled
                } else if (window.cachedImages.indexOf(hash) !== -1 && window.settings.imgOfflineSets.indexOf(this.state.details.id) === -1) {
                    images.push({
                        link: image,
                        cardId: this.state.cards[i].id
                    })
                } else {
                    console.log("%%%%%% no action needed")
                }
            }
        }

        const TOTAL_IMAGES_COUNT = images.length
        let waves = [];
        let totalDownlaods = 0;

        if (window.settings.imgOfflineSets.indexOf(this.state.details.id) !== -1) {
            console.log("%% Image Downloads enabled ==> DOWNLAODING IMAGES OF " + TOTAL_IMAGES_COUNT)
            let error = false;
            let success = false;
            if (TOTAL_IMAGES_COUNT !== 0) {
                while (images.length !== 0) {
                    waves.push(images.splice(0, 5));
                    console.log("%% images to download", waves);
                }
                for (let i = 0; i < waves.length; i++) {
                    const thisWave = waves[i];
                    console.log("%% downloading", thisWave);
                    const promiseAllRes = await Promise.all(thisWave.map(image => new Promise( async (resolve, reject) => {
                        let res = await Utilities.getImage(image.cardId, image.link, image.thumbnail ? true : false, "-");
                        totalDownlaods++;
                        if (!silent) {
                            this.setState({
                                nonBlockingLoading: "Cached " + totalDownlaods + " images out of " + TOTAL_IMAGES_COUNT
                            })
                        }
                        resolve(res);
                    }))).catch(e => {
                        console.error("Promise error all", e)
                        error = true;
                    });
                    console.log("%% download WAVE END", promiseAllRes);
                }
                localStorage.setItem("cachedImages", JSON.stringify(window.cachedImages))
                success = true;
            }
            this.setState({
                nonBlockingLoading: null
            })
            if (error && !silent) {
                window.toast("Failed to cache some full-sized images.", "error")
            } else if (!error && success && !silent) {
                window.toast("All images are now available while offline in this set", "success")
            }
        } else {
            console.log("%% Image Downloads disabled ==> DELETING IMAGES OF " + TOTAL_IMAGES_COUNT);
            console.log("%%cached images array before ");
            console.log(window.cachedImages)
            if (TOTAL_IMAGES_COUNT !== 0) {
                for (let i = 0; i < images.length; i++) {
                    const image = images[i];
                    const fileName = image.link.split("/")[5].split("?")[0];
                    let hash = "image-" + (fileName.replace("image-image-", "").replace("image-", "").replace("thumb-", ""));
                    let uri = await Filesystem.getUri({ directory: Directory.Data, path: hash + ".txt" });
                    if (uri && uri.uri) {
                        let res = await Filesystem.deleteFile({ path: uri.uri }).catch(e => { console.log("%% File not found", e) });
                        console.log("%% File deleted")
                    } else {
                        console.log("%% File could not be deleted")
                    }
                    console.log("%%% deallication hash of " + hash + "[" + window.cachedImages.length + "]")
                    if (window.cachedImages.indexOf(hash) !== -1) {
                        window.cachedImages.splice(window.cachedImages.indexOf(hash), 1);
                    }
                    console.log("%%% DONE deallication hash of " + hash + "[" + window.cachedImages.length + "]")
                }
                localStorage.setItem("cachedImages", JSON.stringify(window.cachedImages))
                console.log("%%cached images array after ");
                console.log(window.cachedImages)
                window.toast("Offline image cache is cleared for this set", "success")
            }
        }
    
        // console.log("%% images to download", images, window.cachedImages)
        // Utilities.getImage(item.id, image, true, rand);
    }

    // async cacheThumbnails() {
    //     console.log("%% cacheThumbnails");
    // }

    async ionViewWillEnter() {
        if (window.location.pathname.startsWith("/studyset") && localStorage.getItem("justEndedPractice")) {
            localStorage.removeItem("justEndedPractice");
            let beforePractice = await Storage.getO("statsBeforePractice");
            let afterPractice = await Utilities.getReviewEndStats();
            Storage.remove("statsBeforePractice");
    
            if (beforePractice && afterPractice) {
                if (beforePractice.learnt === afterPractice.learnt && beforePractice.mastered === afterPractice.mastered && beforePractice.reviews === afterPractice.reviews && beforePractice.reviewedCardIdsToday === afterPractice.reviewedCardIdsToday ) { } else {
                    this.setState({
                        reviewModal: {
                            before: beforePractice,
                            after: afterPractice
                        }
                    })
                }
            }
        }
    }

    getFlag() {
        if (this.state.details.term) {
            let termLangauge = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.details.term)
            if (termLangauge) {
                let flagObj = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangauge];
                if (flagObj) {
                    this.setState({
                        termFlag: flagObj.logo
                    })
                }
            }
        }
        if (this.state.details.definition) {
            let termLangauge = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, this.state.details.definition)
            if (termLangauge) {
                let flagObj = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[termLangauge];
                if (flagObj) {
                    this.setState({
                        definitionFlag: flagObj.logo
                    })
                }
            }
        }
    }

    calculatePendingCardShareUpdates() {
        if (this.state.canPushUpdates && this.state.details.lastPushed) {
            let updateCount = 0;
            for (let i = 0; i < this.state.cards.length; i++) {
                const card = this.state.cards[i];
                if (card.updatedAtTimestamp > this.state.details.lastPushed) {
                    updateCount++
                }
            }
            this.setState({
                pendingCardShareUpdates: updateCount
            })
        }
    }

    async ionViewDidEnter() {
        this.load();
    }

    async sort() {

        Utilities.trackEvent("Flashcards", "Studyset Sort", this.state.sortBy + "|" + this.state.sortOrder);

        const cards = await SQLStorage.getAllCardsFromStudyset(this.state.details.id, this.state.sortBy, this.state.sortOrder);

        this.setState({
            cards: cards,
            currentPage: 0,
            visibleCards: [],
        }, function() {
            this.paginate();
        })

    }

    async isAlreadyAdded(newId) {
        const set = await SQLStorage.getStudysetBySlug(newId)
        return set;
    }

    async downloadSet() {

        Utilities.trackEvent("Studyset", "Studyset Download", this.state.details.id + "|" + this.state.details.name);

        if (!window.db) {
            // localStorage.setItem("preventAppOpenTrack", "true")
            // window.location.href = "/unsupported-browser"
            return;
        }

        this.setState({
            loading: true
        })

        const newId = this.state.details.id

        let newStudyset = {
            name: this.state.details.name,
            term: this.state.details.term,
            definition: this.state.details.definition,
            createdAt: new Date(),
            updatedAt: new Date(),
            id: newId,
            owner: this.state.details.owner,
            viewSecret: this.state.details.viewSecret,
            lastFetched: Utilities.timestamp(),
            ownerUsername: this.state.details.ownerUsername,
            ownerImageUrl: this.state.details.ownerImageUrl
        }

        let words = this.state.cards;
        let now = Utilities.dateSub(new Date(), "second", 3);

        words = words.map(item => {
            item.createdAt = new Date(now);
            item.updatedAt = new Date(now);
            item.setId = newId;
            return item;
        })

        let queueForUploadList = [];
        await SQLStorage.saveCard(words, true, true);
        await SQLStorage.saveSet(newStudyset);

        window.toast(window.ln.setSavedToYourCollection, "success");

        for (var i = 0; i < words.length; i++) {
            let card = words[i];
            queueForUploadList.push(["card", card.id + "-" + card.setId]);
        }

        await window.dropbox.queueForUpload("set", newId)
        await window.dropbox.queueForUpload(queueForUploadList);
        store.dispatch(updatedSetsSet([newId]))

        this.setState({
            loading: false
        })

        localStorage.setItem("openSet", newId);
        this.props.history.push("/sets");
        // window.location.replace("/studyset/" + newId);

    }

    async load() {

        this.setState({ definitionFlag: null, termFlag: null, loading: true, mode: window.location.href.indexOf("/set/") !== -1 ? "preview" : "normal" });

        let id = this.props.match.params.id;
        let action = this.state.action;

        this.setState({
            allowUninitedPractice: false
        })

        if (window.location.href.indexOf("/set/") !== -1) {

            Utilities.trackEvent("Studyset", "Studyset Load Public", id);

            const alreadyAdded = await this.isAlreadyAdded(id);
            if (alreadyAdded) {
                this.setState({
                    loading: false
                }, () => {
                    localStorage.setItem("openSet", alreadyAdded.id);
                    this.props.history.push("/sets");  
                })
                return;
            }

            let set = await Server.getPublicSet(id);

            if (!set) {
                window.toast("Failed to get set", "error");
                this.setState({
                    loading: false
                })
                this.props.history.goBack();
                return;
            }

            this.setState({
                details: {
                    name: set.name,
                    term: set.term,
                    definition: set.definition,
                    owner: set.owner,
                    ownerImageUrl: set.ownerDetails ? (set.ownerDetails.image || "") : "",
                    ownerUsername: set.ownerDetails ? (set.ownerDetails.username || "") : "",
                    viewSecret: set.viewSecret,
                    id: set.localId,
                    source: set.source,
                    description: set.description || null,
                    // tags: set.tags || [],
                },
                ownerDetails: set.ownerDetails || null,
                cards: set.cards.map(card => {
                    return {
                        id: card.localId,
                        term: card.term,
                        definition: card.definition,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                        setId: set.localId,
                        strength: "0",
                        history: [],
                        customText2: card.customFields || [],
                        customText1: card.imageThumbnails || [],
                        image: card.imageLinks || [],
                        links: [],
                        tags: [],
                    }
                }),
                currentPage: 0,
                type: action,
                tags: [],
                visibleCards: [],
                loading: false,
                filters: [],
                sortBy: "createdAt",
                sortOrder: "DESC",
                allowUninitedPractice: true
            }, function() {

                Utilities.writeCustomMetaTags();
                document.title = this.state.details.name + " | Flashcards made Simple";
                const metaDescription = "Start studying " + this.state.details.name + " containing " + this.state.cards.length + " flashcards with Flashcards made Simple" + ( this.state.details.term !== this.state.details.definition ? (" to study " + this.state.details.term + " or " + this.state.details.definition) : "" ) + "."; 

                let link = document.createElement('meta'); link.setAttribute('name', 'description');  link.content = metaDescription; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('property', 'og:type');  link.content = "article"; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('property', 'og:locale');  link.content = "en_US"; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('property', 'og:site_name');  link.content = "Flashcards made Simple"; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('property', 'og:title');  link.content = document.title; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('property', 'og:url');  link.content = window.location.href; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('property', 'og:description');  link.content = metaDescription; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('property', 'og:image');  link.content = "https://firebasestorage.googleapis.com/v0/b/simpleflashcardmanager.appspot.com/o/website%2Fcover-min.png?alt=media&token=f8b2b84b-14a1-43cf-aaba-13b482e54577"; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('name', 'twitter:title');  link.content = document.title; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('name', 'twitter:description');  link.content = metaDescription; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('name', 'twitter:card');  link.content = "summary_large_image"; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('name', 'twitter:url');  link.content = window.location.href; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('name', 'twitter:title');  link.content = document.title; document.getElementsByTagName('head')[0].appendChild(link);
                link = document.createElement('meta'); link.setAttribute('name', 'twitter:image');  link.content = "https://firebasestorage.googleapis.com/v0/b/simpleflashcardmanager.appspot.com/o/website%2Fcover-min.png?alt=media&token=f8b2b84b-14a1-43cf-aaba-13b482e54577"; document.getElementsByTagName('head')[0].appendChild(link);

                this.paginate();
                setTimeout(function() { this.checkPronouncationAvailability(); }.bind(this), 400);

                if (this.state.allowUninitedPractice) {
                    setTimeout(() => {
                        if (window.location.href.indexOf("action=practice") !== -1 && localStorage.getItem("preventUninitedAutolaunchPractice") !== set.localId) {
                            localStorage.setItem("preventUninitedAutolaunchPractice", set.localId)
                            Utilities.onDrawerShow();
                            this.setState({
                                selectPracticeType: true,
                                selectedPracticeTypeNumber: this.state.filters.length > 0 ? this.state.visibleCards.length : this.state.cards.length,
                                chunkSize: 50
                            })
                        }
                    }, 250)
                }

                if (window.location.href.indexOf("action=autoadd") !== -1) {
                    this.downloadSet();
                }

                if (window.location.href.indexOf("source=cnc-print") !== -1) {
                    this.setState({
                        printingModal: true
                    })
                }
            })

        } else {

            let studyset = (id === "archived") ? { name: window.ln.archivedCards, id: id } : (await SQLStorage.getStudyset(id));
            let cards = (id === "archived") ? (await SQLStorage.getAllArchivedCards()) : (await SQLStorage.getAllCardsFromStudyset(id, "createdAt", "DESC"));
            let tags = await SQLStorage.getTags();
            let tagReferences = await SQLStorage.getTagReferencesBySet(id, id === "archived");

            Utilities.trackEvent("Studyset", "Studyset Load Private", studyset.id + "|" + studyset.name);
    
            if (!studyset) {
                localStorage.setItem("preventAppOpenTrack", "true")
                window.location.href = "/"
                return;
            }

            this.setState({
                details: studyset,
                cards: cards,
                currentPage: 0,
                type: action,
                tags: tags,
                visibleCards: [],
                loading: false,
                filters: tagReferences,
                ownerDetails: studyset.owner && studyset.ownerUsername ? { _id: studyset.owner, username: studyset.ownerUsername, image: studyset.ownerImageUrl } : null,
                description: null,
                canPushUpdates: (studyset.owner && window.settings && window.settings.account && window.settings.account.id == studyset.owner)
            }, function() {
                this.paginate();
                this.calculatePendingCardShareUpdates();
                this.getFlag();
                setTimeout(function() { 
                    this.checkPronouncationAvailability();
                    if (this.state.details.owner && ( (window.settings && window.settings.account && window.settings.account.id != this.state.details.owner) || (window.settings && !window.settings.account) )) {
                        this.getShareUpdates(true);   
                    }
                }.bind(this), 400);

                if (window.location.href.indexOf("/justcreated") !== -1) {
                    store.dispatch(updatedSetsSet([this.state.details.id]))
                    this.setState({ action: "edit" }, function() {
                        if (this.studysetNameRef && this.studysetNameRef.current) {
                            setTimeout(function() {
                                const el = document.getElementById("studyset-name").querySelector("input");
                                if (el) {
                                    el.focus();
                                }
                            }.bind(this), 300)
                        }
                    })
                }

                if (window.os !== "web") {
                    this.cacheFullsizedImages();   
                }
            })

        }

    }

    paginate() {

        if (this.isLoadingMore) {
            return;
        }

        this.isLoadingMore = true;
        let currentPage = this.state.currentPage;
        let newVisibleCards = this.state.visibleCards.concat(JSON.parse(JSON.stringify(this.state.cards)).splice(CARDS_PER_PAGE*currentPage, CARDS_PER_PAGE));

        if ( (newVisibleCards.length === this.state.visibleCards.length) && (newVisibleCards.length !== 0) ) {
            return;
        }

        this.setState({
            visibleCards: newVisibleCards,
            currentPage: currentPage+1,
            fullscreenLoading: false
        }, function() {
            this.isLoadingMore = false;
        })

    }

    updateTagReferences(tagId, increase) {
        let tagReferences = this.state.filters;
        for (let i = 0; i < tagReferences.length; i++) {
            if (tagReferences[i].tagId === tagId) {
                tagReferences[i].count = (increase) ? (tagReferences[i].count+1) : (tagReferences[i].count-1)
                this.setState({ filters: tagReferences })
                return;
            }
        }
        // Not in yet, so we have to do it manually;
        this.setState({ manualTagFilterRefreshOnSave: true })
    }

    async addCard() {

        if (this.state.cards.length > 499 && !window.activated) {
            window.showSubscriptionModal("setcards");
            return;
        }

        if (this.state.cards.length > 2000) {
            this.setState({ limitExceededAlert: true })
            return;
        }

        let cards = this.state.cards;
        let visibleCards = this.state.visibleCards;

        if (this.currentlyEditingId !== null && visibleCards[this.currentlyEditingId]) {
            visibleCards[this.currentlyEditingId].editing = false;
            cards[this.currentlyEditingId].editing = false;
        }

        let newCard = {
            id: "" + Utilities.getId(),
            term: "",
            definition: "",
            tags: [],
            createdAt: new Date(),
            updatedAt: new Date(),
            setId: this.state.details.id,
            editing: true,
            strength: "0",
            history: [],
            notYetSaved: true,
            customText2: [],
            links: []
        };

        cards.unshift(newCard);
        visibleCards.unshift(newCard);
        this.currentlyEditingId = 0;

        this.listRef.current.scrollTop = 0;

        this.setState({
            cards: cards,
            visibleCards: visibleCards,
            openCardI: 0,
            openCardNew: true
        }, function() {
            setTimeout(function() {
                let element = document.getElementById("0-term");
                if ( (element) && (element.childNodes[0]) ) {
                    element.childNodes[0].focus();
                }
            }.bind(this), 100);
        })

    }

    handleChange(key, value) {
        let details = this.state.details;
        details[key] = value;
        this.setState({
            details: details,
            hasChanged: true
        }, function() {
            this.checkPronouncationAvailability();
            this.saveDetails();
        })
    }

    async deleteSet() {
        Utilities.trackEvent("Studyset", "Studyset Delete", this.state.details.id + "|" + this.state.details.name);

        setTimeout(async () => {
            await SQLStorage.deleteSet(this.state.details.id);

            let queued = await window.dropbox.queueForUpload(this.state.cards.map(item => {
                return [
                    "card",
                    item.id + "-" + item.setId
                ]
            }));
    
            queued = await window.dropbox.queueForUpload("set", this.state.details.id)
    
            store.dispatch(updatedSetsSet([this.state.details.id]))
            this.props.history.goBack();
        }, 1000)
    }

    async saveDetails() {
        await SQLStorage.saveSet(this.state.details);
        store.dispatch(updatedSetsSet([this.state.details.id]))
        await window.dropbox.queueForUpload("set", this.state.details.id)
    }

    checkPronouncationAvailability() {

        if (window.globalVars.availableLanguages) {
            if (window.globalVars.availableLanguages.indexOf(this.state.details.term) > -1) this.setState({ termPronouncation: true  })
            if (window.globalVars.availableLanguages.indexOf(this.state.details.definition) > -1) this.setState({ definitionPronouncation: true  })
        }

    }

    filter = () => {

        const FILTERS = this.state.activeFilters;
        const KEYWORDS = this.state.keywords;
        let cards = this.state.cards;
        let visibleCards = [];

        if (FILTERS.length === 0 && !KEYWORDS) {

            this.setState({
                visibleCards: cards
            })

        } else {

            Utilities.trackEvent("Flashcards", "Flashcards Studyset Search", KEYWORDS.trim().toLowerCase() + "|" + FILTERS.join(","));

            for (let i = 0; i < cards.length; i++) {

                const card = cards[i];

                if (KEYWORDS) { 
                    if (card.term.toLowerCase().indexOf(KEYWORDS) !== -1 || card.definition.toLowerCase().indexOf(KEYWORDS) !== -1 || card.customText2.join("").toLowerCase().indexOf(KEYWORDS) !== -1) {
                        if (FILTERS.length === 0) {
                            visibleCards.push(card); 
                            continue;
                        }
                    } else {
                        continue;
                    }
                }

                if (FILTERS.indexOf("star") !== -1 && card.star) { visibleCards.push(card); continue; }
                if (FILTERS.indexOf("studying") !== -1 && card.strength === 1) { visibleCards.push(card); continue; }
                if (FILTERS.indexOf("learnt") !== -1 && card.strength === 3) { visibleCards.push(card); continue; }
                if (FILTERS.indexOf("mastered") !== -1 && card.strength === 5) { visibleCards.push(card); continue; }
                if (FILTERS.indexOf("new") !== -1 && card.strength === 0) { visibleCards.push(card); continue; }
                if (FILTERS.indexOf("image") !== -1 && card.image.length > 0) { visibleCards.push(card); continue; }

                const int = card.tags && card.tags.filter(value => FILTERS.includes(value));
                if (int && int.length !== 0) { visibleCards.push(card); continue; }
    
            }

            this.setState({
                visibleCards: visibleCards
            })

        }

    }

    editTag = (id) => {

        this.setState({
            currentlyEditedTag: (id === "new") ? {
                id: "" + Utilities.getId(),
                color: "1",
                name: "",
                createdAt: new Date(),
                updatedAt: new Date(),
            } : this.state.tags.filter(item => { return (item.id === id) })[0]
        })

    }

    async saveTag(tag) {

        let tags = this.state.tags;

        this.setState({
            tags: [...this.state.tags, tag],
        })

        await SQLStorage.saveTag(tag);
        await window.dropbox.queueForUpload("tag", tag.id)

    }

    closeHelpOverlay() {
        let el = document.getElementById("help-overlay");
        if (el) {
            el.click();
        }
    }

    async updateShare() {

        if (this.state.cards.length === 0) {
            window.toast(window.ln.atLeastOneCardToShare, "error");
            return;
        }

        this.setState({ loading: window.ln.sharingCards + " ..." });

        let shareDetails = await Server.shareSet({
            ...this.state.details,
            tags: []
        }, this.state.cards).catch(e => {
            window.toast(window.ln.networkError + " " + JSON.stringify(e), "error");
        });

        this.setState({ loading: false });

        if (shareDetails && shareDetails.viewSecret && shareDetails.editSecret && shareDetails.owner) {
            Utilities.trackEvent("Studyset", "Studyset Share Update Push", this.state.details.id + "|" + this.state.details.name);

            let newDetails = this.state.details;
            newDetails.lastPushed = Utilities.timestamp();
            this.setState({
                details: newDetails,
                pendingCardShareUpdates: 0
            }, () => {
                this.saveDetails();
                window.toast(window.ln.published, "success");
                this.setState({
                    canPushUpdates: (this.state.details.owner && window.settings && window.settings.account && window.settings.account.id == this.state.details.owner)
                })
            })
        }

    }

    async getShareUpdates(silent) {

        Utilities.trackEvent("Studyset", "Studyset Share Update Check", this.state.details.id + "|" + this.state.details.name);

        if (!silent)
            this.setState({ loading: window.ln.loading + " ..." });
        
        let set = await Server.getPublicSet(this.state.details.viewSecret);

        if (!silent)
            this.setState({ loading: false })

        if (!set) {
            if (!silent)
                window.toast(window.ln.networkError, "error");
            return;
        }
    
        let currentServerStateCards = set.cards.map(card => {
            return {
                id: card.localId,
                term: card.term,
                definition: card.definition,
                createdAt: new Date(),
                updatedAt: new Date(),
                setId: set.localId,
                strength: "0",
                history: [],
                customText2: card.customFields || [],
                customText1: card.imageThumbnails || [],
                image: card.imageLinks || [],
                links: [],
                tags: [],
            }
        });

        let currentLocalStateCards = JSON.parse(JSON.stringify(this.state.cards));

        let updatedCards = [];
        let deletedCards = [];
        let newCards = [];

        for (let i = 0; i < currentServerStateCards.length; i++) {
            const newCard = currentServerStateCards[i];
            const oldCard = currentLocalStateCards.find(card => (card.id + "" == newCard.id + ""));

            if (!oldCard) {
                newCards.push(newCard);
            } else {
                const isSame = newCard.term === oldCard.term && newCard.definition === oldCard.definition && JSON.stringify(newCard.customText1) === JSON.stringify(oldCard.customText1) && JSON.stringify(newCard.customText2) === JSON.stringify(oldCard.customText2) && JSON.stringify(newCard.image) === JSON.stringify(oldCard.image)
                if (!isSame) {
                    newCard.currentLocalState = JSON.parse(JSON.stringify(oldCard));
                    updatedCards.push(newCard)
                }
            }

            currentLocalStateCards = currentLocalStateCards.filter(card => card.id + "" != newCard.id + "");
        }

        deletedCards = currentLocalStateCards;

        if (newCards.length !== 0 || deletedCards.length !== 0 || updatedCards.length !== 0) {
            window.preventFocusBlurTrack = true;
            if (window.confirm(window.ln.updatesDetected.replace("__", deletedCards.length).replace("___", updatedCards.length).replace("____", newCards.length)) ) {
                Utilities.trackEvent("Studyset", "Studyset Share Update Fetch", this.state.details.id + "|" + this.state.details.name);
                
                let queueForUploadList = [];
                const now = new Date();

                for (let i = 0; i < newCards.length; i++) {
                    let card = newCards[i];
                    card.createdAt = now;
                    card.updatedAt = now;
                    await SQLStorage.saveCard(card, true, true);
                    queueForUploadList.push(["card", card.id + "-" + card.setId]);
                }

                for (let i = 0; i < updatedCards.length; i++) {
                    let card = updatedCards[i].currentLocalState;
                    card.createdAt = now;
                    card.updatedAt = now;
                    card.term = updatedCards[i].term;
                    card.definition = updatedCards[i].definition;
                    card.image = updatedCards[i].image;
                    card.customText1 = updatedCards[i].customText1;
                    card.customText2 = updatedCards[i].customText2;
                    await SQLStorage.saveCard(card, true, true);
                    queueForUploadList.push(["card", card.id + "-" + card.setId]);
                }

                for (let i = 0; i < deletedCards.length; i++) {
                    const card = deletedCards[i];
                    // store.dispatch(updatedSetsSet([this.state.flashcard.setId]))
                    await SQLStorage.deleteCard(card.id);
                    queueForUploadList.push(["card", card.id + "-" + card.setId]);
                }

                await window.dropbox.queueForUpload(queueForUploadList);

                let newDetails = this.state.details;
                newDetails.lastFetched = Utilities.timestamp();
                this.setState({
                    detail: newDetails
                }, () => {
                    this.saveDetails();
                })

                window.toast(window.ln.updatesApplied, "success");
                localStorage.setItem("preventAppOpenTrack", "true")
                window.location.reload();

            }
            setTimeout(() => {
                window.preventFocusBlurTrack = false;
            }, 300);
        } else {
            if (!silent)
                window.toast(window.ln.alreadyUpToDate);
        }
    }

    async createShare() {

        Utilities.trackEvent("Studyset", "Studyset Share Create Click", this.state.details.id + "|" + this.state.details.name);

        if (!window.settings.account) {
            window.preventFocusBlurTrack = true;
            if (window.confirm(window.ln.signUpOrLoginToCont)) {
                localStorage.setItem("auto-signup-tap", "true"); 
                localStorage.setItem("preventAppOpenTrack", "true")
                window.location.href = "/settings";
            }
            setTimeout(() => {
                window.preventFocusBlurTrack = false;
            }, 300);
            return;
        }

        if (this.state.cards.length === 0) {
            window.toast(window.ln.atLeastOneCardToShare, "error");
            return;
        }

        this.setState({ loading: window.ln.publishingStudyset  +  " ..." })

        let shareDetails = await Server.createShareCredentials(this.state.details.id).catch(e => {
            window.toast(window.ln.networkError + " " + JSON.stringify(e), "error");
        });

        Utilities.trackEvent("Studyset", "Studyset Share Create", this.state.details.id + "|" + this.state.details.name);

        this.setState({ loading: false })

        if (shareDetails && shareDetails.viewSecret && shareDetails.editSecret && shareDetails.owner) {
            let newDetails = this.state.details;
            newDetails.viewSecret = shareDetails.viewSecret;
            newDetails.editSecret = shareDetails.editSecret
            newDetails.owner = shareDetails.owner
            this.setState({
                details: newDetails
            }, () => {
                this.saveDetails();
                this.updateShare();
            })
        }
    }

    render() {

        let currentFilterCount = 0;

        return (
         <IonPage data-page="studyset" ref={this.pageRef}>
            <IonHeader onClick={() => {  }}>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton defaultHref="/" text={window.ln.back} onClick={() => {
                            if (this.state.action === "view") {
                                this.props.history.goBack();
                            } else {
                                this.setState({ action: "view" })
                                this.checkPronouncationAvailability();
                            }
                        }} />
                    </IonButtons>
                    <IonTitle>{this.state.details && this.state.details.id === "archived" ? window.ln.archivedCards : window.ln.studyset}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                { (this.state.loading) &&
                    <IonLoading
                        isOpen={this.state.loading !== false && this.state.reviewModal === null}
                        message={typeof this.state.loading === "string" ? this.state.loading : window.ln.loading}
                        duration={10000}
                    />
                }
                <div className="background" ref={this.listRef} onScroll={(e) => {
                    if (this.state.activeFilters.length === 0 && (e.target.scrollTop + e.target.clientHeight + 200 > e.target.scrollHeight) ) {
                        this.paginate();
                    }
                }}>
                { (this.state.showGuide) &&
                    <HelpOverlay 
                        view="studyset-modal"
                        close={() => { this.setState({ showGuide: false }) }}
                    />    
                }
                { (this.state.action === "view" && this.state.details && this.state.details.id !== "archived") &&
                    <div className="header-main">
                        <h2>
                            {this.state.details.name || window.ln.untitled}
                        </h2>
                        <p>
                            {this.state.termFlag &&
                                <img className="target" src={require('../images/flags/' + this.state.termFlag + '.svg')} />
                            }
                            <span>{this.state.details.term || window.ln.langNotSet}</span>
                            <span> - </span>
                            {this.state.definitionFlag &&
                                <img className="target" src={require('../images/flags/' + this.state.definitionFlag + '.svg')} />
                            }
                            <span>{this.state.details.definition || (window.ln.langNotSet)}</span>
                        </p>
                    </div>
                }
                { (this.state.action === "edit") &&
                    <div className="details" style={{ marginTop: 15 }}>
                        <div className="field">
                            <IonInput id="studyset-name" ref={this.studysetNameRef} value={this.state.details ? this.state.details.name : ""} onIonChange={(e) => {this.handleChange("name", e.target.value)}} placeholder={window.ln.studysetName} type="text"></IonInput>
                        </div>
                        <div 
                            className="info-banner"
                            style={{
                                margin: '15px 15px 0 15px'
                            }}
                        >
                            <IonIcon icon={informationCircleSharp} />
                            <label>
                                {window.ln.pronouncationLangInfo}
                            </label>
                        </div>
                        <div style={{ display: "flex", marginTop: 15 }}>
                            <div className="field" style={{ marginRight: 7.5, flexBasis: '50%' }}>
                                <IonInput 
                                    onIonBlur={() => {
                                        setTimeout(function() { this.setState({ editingLanguageType: null }) }.bind(this), 400)
                                    }} 
                                    onIonFocus={() => {
                                        setTimeout(function() { this.setState({ editingLanguageType: "term" }) }.bind(this), 600)
                                    }}
                                    value={this.state.details ? this.state.details.term : ""} 
                                    onIonChange={(e) => {this.handleChange("term", e.target.value)}} 
                                    placeholder={window.ln.termType} type="text"
                                />
                            </div>
                            <div className="field" ionIonFocus={() => {
                                this.setState({ editingLanguageType: "definition" })
                            }} style={{ marginLeft: 7.5, flexBasis: '50%' }}>
                                <IonInput
                                    onIonBlur={() => {
                                        setTimeout(function() { this.setState({ editingLanguageType: null }) }.bind(this), 400)
                                    }} 
                                    onIonFocus={() => {
                                        setTimeout(function() { this.setState({ editingLanguageType: "definition" }) }.bind(this), 600)
                                    }}
                                    value={this.state.details ? this.state.details.definition : ""}
                                    onIonChange={(e) => {this.handleChange("definition", e.target.value)}} 
                                    placeholder={window.ln.defType}
                                    type="text"
                                />
                            </div>
                        </div>
                        { (
                            (this.state.editingLanguageType) &&
                            (window.globalVars) &&
                            (window.globalVars.allLanguages) &&
                            (window.globalVars.allLanguages.length > 0)
                        ) &&
                            <div className="suggestions">
                                { window.globalVars.allLanguages.map(item => {
                                    if (this.state.editingLanguageType === "term" && this.state.details.term && item.toLowerCase().indexOf(this.state.details.term.toLowerCase()) === -1) return null;
                                    if (this.state.editingLanguageType === "definition" && this.state.details.definition && item.toLowerCase().indexOf(this.state.details.definition.toLowerCase()) === -1) return null;
                                    return (
                                        <IonChip onClick={() => {
                                            this.handleChange(this.state.editingLanguageType, item)
                                        }}>
                                            { window.globalVars.availableLanguages.indexOf(item) > -1 && <IonIcon icon={volumeHigh} /> }
                                            <IonLabel>{item}</IonLabel>
                                        </IonChip>
                                    )
                                }) }
                            </div>
                        }
                        <div className="field" style={{
                            marginTop: 15
                        }}>
                            <IonItem className="long" style={{
                                '--border-color': 'transparent',
                                '--padding-start': 0
                            }}>
                                <IonLabel className='ion-text-wrap'>{window.ln.imgOfflineSets}</IonLabel>
                                <IonToggle
                                    checked={window.settings.imgOfflineSets && window.settings.imgOfflineSets.indexOf(this.state.details.id) !== -1}
                                    onIonChange={ async (e) => {
                                        
                                        if (window.os === "web") {
                                            window.toast(window.ln.unsupportedDeviceCache, "error")
                                            return;
                                        }

                                        if (!window.activated) {
                                            window.showSubscriptionModal("imageCache");
                                            return;
                                        }

                                        let imgOfflineSets = window.settings.imgOfflineSets || [];

                                        const isOff = imgOfflineSets.indexOf(this.state.details.id) === -1;
                                        Utilities.trackEvent("Studyset", "Studyset Image Cache Toggle", null, isOff ? 1 : 0)

                                        if (isOff) {
                                            imgOfflineSets.push(this.state.details.id)
                                        } else {
                                            imgOfflineSets.splice(imgOfflineSets.indexOf(this.state.details.id), 1)
                                        }

                                        await SQLStorage.saveSetting("imgOfflineSets", imgOfflineSets);
                                        await window.dropbox.queueForUpload("setting", "imgOfflineSets");
                                        if (window.location.href.indexOf("justcreated") === -1) {
                                            localStorage.setItem("preventAppOpenTrack", "true")
                                            window.location.reload();
                                        } else {
                                            store.dispatch(updatedSetsSet(['null']))
                                            window.dropbox.debounce(true);   
                                        }
                                    }}
                                />
                            </IonItem>
                        </div>
                        { (window.location.href.indexOf("justcreated") === -1) &&
                            <div className="delete">
                                <button onClick={() => { this.setState({ deleteSetConfirmationAlert: true }) }}>{window.ln.delete}</button>
                            </div>
                        }
                        { (this.state.action === "edit") &&
                            <button
                                onClick={() => {
                                    Utilities.trackEvent("Studyset", "Studyset Save", this.state.details.id + "|" + this.state.details.name + "|" + this.state.details.term + "|" + this.state.details.definition);
                                    this.setState({ 
                                        action: "view",
                                        showGuide: !localStorage.getItem("help-overlay-hidden-studyset-modal"),
                                    }, () => {
                                        window.location.replace(window.location.href.replace("/justcreated", "/"));
                                    })
                                }}
                            >
                                {window.ln.saveStudyset}
                            </button>
                        }
                    </div>
                }
                { (this.state.ownerDetails && this.state.ownerDetails.username) &&
                    <div className='owner-details'>
                        { (this.state.ownerDetails.image) ?
                            <img src={this.state.ownerDetails.image} />
                            :
                            <Avatar
                                size={40}
                                name={this.state.ownerDetails.username}
                                variant="beam"
                                colors={["#92A1C6", "#146A7C", "#F0AB3D", "#C271B4", "#C20D90"]}
                            />
                        }
                        <div>
                            <span>{ window.ln.createdBy }</span>
                            <label>{this.state.ownerDetails.username}</label>
                        </div>
                    </div>
                }
                { (this.state.details && this.state.details.description && this.state.action !== "edit") &&
                    <h3 className="description">
                        {this.state.details.description}
                    </h3>
                }
                {/* { (this.state.details && this.state.details.tags && this.state.details.tags.length !== 0) &&
                    <div className="tags">
                        { this.state.details.tags.map(tag => {
                            return ( <IonChip data-ns={"false"} key={tag} data-color="8"> <IonLabel>{tag}</IonLabel> </IonChip> )
                        }) }
                    </div>
                } */}
                <div className="activities-snap">
                    { (this.state.mode === "preview") &&
                        <div className="activities activities-compact activities-compact-one" style={{ paddingBottom: 0 }}>
                            <div data-activity="edit" id="uninited-practice-btn" onClick={() => {
                                this.setState({ progressNotSavedAlert: true })
                            }}>
                                <IonIcon mode="ios" icon={school} />
                                <div>
                                    <IonLabel>{window.ln.practice}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="edit" id="download-set-btn" onClick={() => {
                                this.downloadSet()
                            }}>
                                <IonIcon mode="ios" icon={addCircle} />
                                <div>
                                    <IonLabel style={{ whiteSpace: 'normal' }}>{window.ln.downloadSet}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="edit" onClick={() => {
                                this.setState({ showShareModal: true })
                            }}>
                                <IonIcon mode="ios" icon={share} />
                                <div>
                                    <IonLabel>{window.ln.share}</IonLabel>
                                </div>
                            </div>
                        </div>
                    }
                    { (this.state.action === "view" && this.state.mode !== "preview" && this.state.details && this.state.details.id !== "archived") &&
                        <div className="activities activities-compact activities-compact-one" style={{ paddingBottom: (this.state.canPushUpdates || (this.state.details && !this.state.details.owner)) ? 0 : 15 }}>
                            <div
                                id="practice-select-btn"
                                data-activity="practice" 
                                onClick={() => {
                                    Utilities.onDrawerShow();
                                    let filtered = (this.state.filters.length > 0 || this.state.keywords !== "");
                                    this.setState({
                                        selectPracticeType: true,
                                        selectedPracticeTypeNumber: filtered ? this.state.visibleCards.length : this.state.cards.length,
                                        chunkSize: 10
                                    })
                                }}
                                style={{
                                    zIndex: this.state.showGuide ? 100000 : undefined,
                                    position: this.state.showGuide ? 'relative' : undefined
                                }}
                            >
                                { (this.state.showGuide) && <ArrowComponent direction="left-bottom" text={window.ln.practiceTypeArrow} styleLabel={{ width: 140 }} style={{ top: -56, left: 26 }} /> }
                                <IonIcon mode="ios" icon={school} />
                                <div>
                                    <IonLabel>{window.ln.practice}</IonLabel>
                                </div>
                            </div>
                            <div 
                                data-activity="share" 
                                onClick={() => {
                                    Utilities.onDrawerShow();
                                    this.setState({ showShareModal: true })
                                }}
                                style={{
                                    zIndex: this.state.showGuide ? 100000 : undefined,
                                    position: this.state.showGuide ? 'relative' : undefined
                                }}
                            >
                                { (this.state.showGuide) && <ArrowComponent direction="left-top" text={window.ln.shareArrow} styleLabel={{ width: 160 }} style={{ top: 64, left: 20 }} /> }
                                <IonIcon mode="ios" icon={people} />
                                <div>
                                    <IonLabel>{window.ln.share}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="edit" onClick={() => {
                                this.setState({ printingModal: true })
                            }}>
                                <IonIcon mode="ios" icon={print} />
                                <div>
                                    <IonLabel>{window.ln.print}</IonLabel>
                                </div>
                            </div>
                        </div>
                    }
                    { (this.state.action === "view" && (this.state.canPushUpdates || (this.state.details && !this.state.details.owner)) && this.state.mode !== "preview" && this.state.details && this.state.details.id !== "archived") &&
                        <div className="activities activities-compact activities-compact-one">
                            <div 
                                data-activity="import" 
                                onClick={() => {
                                    this.setState({ exportImportModal: 'import' })
                                    this.closeHelpOverlay();
                                }}
                                style={{
                                    zIndex: this.state.showGuide ? 100000 : undefined,
                                    position: this.state.showGuide ? 'relative' : undefined
                                }}
                            >
                                <IonIcon mode="ios" icon={arrowRedo} />
                                <div>
                                    <IonLabel>{window.ln.import}</IonLabel>
                                </div>
                                { (this.state.showGuide) && <ArrowComponent direction="left-top" text={window.ln.arrowImport} styleLabel={{ width: 142 }} style={{ top: 65, left: 24 }} /> }
                            </div>
                            <div data-activity="export" onClick={() => {
                                this.setState({ exportImportModal: 'export' })
                            }}>
                                <IonIcon mode="ios" icon={arrowUndo} />
                                <div>
                                    <IonLabel>{window.ln.export}</IonLabel>
                                </div>
                            </div>
                            <div data-activity="edit" onClick={() => {
                                this.setState({ action: "edit" }) 
                            }}>
                                <IonIcon mode="ios" icon={create} />
                                <div>
                                    <IonLabel>{window.ln.edit}</IonLabel>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                { (this.state.action === "view") &&
                    <div className="search-filters">
                        <div className="search" style={ (this.state.mode === "preview" || (this.state.details && this.state.details.id === "archived")) ? { marginTop: 15 } : {  } }>
                            <IonSearchbar
                                debounce={400}
                                id="search-bar"
                                showCancelButton="never"
                                value={this.state.keywords}
                                onIonChange={(e) => {
                                    this.setState({
                                        keywords: e.target.value.trim().toLowerCase()
                                    }, function() {
                                        this.filter()
                                    })
                                }}
                                placeholder={window.ln.search}
                            />
                            { this.state.mode !== "preview" && this.state.details && this.state.details.id !== "archived" &&
                                <div className="sort-btn" onClick={() => { 
                                    const elements = document.getElementsByTagName("body");
                                    if (elements && elements[0]) {
                                        elements[0].classList = ""
                                    }
                                    this.setState({ sortPicker: true }) 
                                } }>
                                    <span>
                                        { (this.state.sortBy === "createdAt") ?
                                            (window.ln.createdAtSortBy) :
                                            (this.state.sortBy === "lastReviewed") ?
                                                (window.ln.lastReviewedSortBy) :
                                                (this.state.sortBy === "reviewCount") ?
                                                    (window.ln.reviewCountSortBy) :
                                                    (this.state.sortBy === "strength") ?
                                                        (window.ln.strengthSortBy) :
                                                        (this.state.sortBy === "term") ?
                                                            (window.ln.termSortBy) :
                                                            (this.state.sortBy === "definition") ?
                                                                (window.ln.definitionSortBy ) :
                                                                "-"
                                        }
                                    </span>
                                    <IonIcon icon={ (this.state.sortOrder === "DESC") ? caretDown : caretUp} />
                                </div>
                            }
                        </div>
                        <div className="filters">
                            { this.state.filters.map(tag => {
                                let tagName = (tag.tagId === "star") ? window.ln.starred : (tag.tagId === "studying" || tag.tagId === "new" || tag.tagId === "learnt" || tag.tagId === "image" || tag.tagId === "recording" || tag.tagId === "mastered") ? Utilities.capitalize(window.ln[tag.tagId]): tag.tagName;
                                return (
                                    <IonChip key={tag.tagId} data-ns={this.state.activeFilters.indexOf(tag.tagId) !== -1 ? "false" : "true"} data-color={tag.tagColor} onClick={() => {
                                        let activeFilters = this.state.activeFilters;
                                        if (activeFilters.indexOf(tag.tagId) === -1) {
                                            activeFilters.push(tag.tagId);
                                        } else {
                                            activeFilters.splice(activeFilters.indexOf(tag.tagId), 1);
                                        }
                                        this.setState({ activeFilters: activeFilters }, function() {
                                            this.filter();
                                        })
                                    }}>
                                        { (tag.tagId === "star") && <IonIcon icon={star}/> }
                                        { (tag.tagId === "studying") && <IonIcon icon={playCircle}/> }
                                        { (tag.tagId === "new") && <IonIcon icon={caretUpCircle}/> }
                                        { (tag.tagId === "learnt") && <IonIcon icon={checkmarkCircle}/> }
                                        { (tag.tagId === "mastered") && <IonIcon icon={checkmarkDoneCircle}/> }
                                        { (tag.tagId === "image") && <IonIcon icon={image}/> }
                                        <IonLabel>
                                            {tagName}
                                            <span>{tag.count}</span>
                                        </IonLabel>
                                    </IonChip>
                                )
                            }) }
                        </div>
                    </div>
                }
                { (this.state.action === "view" && this.state.mode !== "preview" && this.state.cards) &&
                    <div className="header">
                        <h2>{ (this.state.activeFilters.length === 0 && !this.state.keywords) ? window.ln.showingAllCards : window.ln.showingOutOfCards.replace("__", this.state.visibleCards.length).replace("___", this.state.cards.length) }</h2>
                    </div>
                }
                { (this.state.details && this.state.details.id === "archived") &&
                    <div className="header">
                        <h2>{window.ln.tapToUnarchive}</h2>
                    </div>
                }
                { (this.state.action === "view") &&
                    <div className="cards-wrapper">
                        <div className="cards">
                            { this.state.visibleCards && this.state.visibleCards.map((item, i) =>  {
                                if (item.notYetSaved) return null;
                                return (
                                    <Flashcard
                                        key={item.id}
                                        onClick={ async () => {
                                            if (window.location.href.indexOf("/set/") !== -1) return null;

                                            if (this.state.details && this.state.details.id === "archived") {

                                                let cardUnarchived = JSON.parse(JSON.stringify(item));
                                                cardUnarchived.customInt1 = null;
                                                await SQLStorage.saveCard(cardUnarchived, false, true);
                                                store.dispatch(updatedSetsSet([cardUnarchived.setId]))
                                                await window.dropbox.queueForUpload("card", cardUnarchived.id + "-" + cardUnarchived.setId);

                                                let visibleCards = this.state.visibleCards;
                                                let cards = this.state.cards;
                                                cards.splice(i, 1)
                                                visibleCards.splice(i, 1)
                                                this.setState({ cards: cards, visibleCards: visibleCards })

                                            } else {
                                                if (this.state.visibleCards.length === this.state.cards.length) {
                                                    this.setState({ openCardI: i });
                                                } else {
                                                    this.setState({ openCardI: this.state.cards.map(subitem => subitem.id).indexOf(item.id) });
                                                }
                                            }
                                        }}
                                        tags={this.state.tags}
                                        flashcard={item} 
                                        i={i} 
                                        definition={this.state.details.definition} 
                                        term={this.state.details.term} 
                                        definitionPronouncation={this.state.definitionPronouncation} 
                                        termPronouncation={this.state.termPronouncation} 
                                    />
                                )
                            }) }
                        </div>
                    </div>
                }
            </div>
            </IonContent>
            { (this.state.mode === "preview") ?
                null
                :
                <IonFab 
                    vertical="bottom" 
                    horizontal="start" 
                    slot="fixed" 
                    style={{ 
                        width: "calc(100% - 20px)", 
                        display: "flex", 
                        justifyContent: "center", 
                        marginBottom: 10,
                        zIndex: this.state.showGuide ? 100000 : undefined,
                        position: this.state.showGuide ? 'relative' : undefined
                    }}
                >
                    { (this.state.action === "view" && (this.state.activeFilters.length !== 0 || this.state.keywords) ) &&
                        <IonFabButton style={{ width: 140, '--border-radius': '56px', marginRight: 15 }} onClick={() => {
                            if (document.querySelector("#practice-select-btn")) {
                                document.querySelector("#practice-select-btn").click();
                            }
                        }}>
                            <IonIcon icon={school} />
                            <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{window.ln.practice + " " + this.state.visibleCards.length}</IonLabel>
                        </IonFabButton>
                    }
                    { (this.state.action === "view" && (this.state.activeFilters.length !== 0 || this.state.keywords) ) &&
                        <IonFabButton style={{ width: 140, '--border-radius': '56px', '--background': '#fb5b5a' }} onClick={() => {
                            this.setState({
                                keywords: "",
                                activeFilters: []
                            }, function() {
                                this.filter()
                            })
                        }}>
                            <IonIcon icon={closeCircle} />
                            <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{window.ln.clearFilters}</IonLabel>
                        </IonFabButton>
                    }
                    { (this.state.action === "view" && this.state.details && this.state.details.id !== "archived" && !(this.state.activeFilters.length !== 0 || this.state.keywords)) &&
                        <IonFabButton 
                            style={{ 
                                width: 156,
                                '--border-radius': '56px'
                            }} 
                            onClick={() => {
                                if (this.state.canPushUpdates || !this.state.details.owner) {
                                    Utilities.onDrawerShow();
                                    this.closeHelpOverlay();
                                    this.addCard()
                                } else {
                                    window.toast(window.ln.noSetUpdateAccess + (!window.settings.account ? (" " + window.ln.confirmSetOwnerLogin) : ""), "error")
                                }
                            }}
                        >
                            <IonIcon icon={addCircle} />
                            <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{window.ln.addNewCard}</IonLabel>
                        </IonFabButton>
                    }
                    { (this.state.canPushUpdates && this.state.pendingCardShareUpdates !== 0) &&
                        <IonFabButton 
                            style={{ 
                                width: 156,
                                '--border-radius': '56px',
                                marginLeft: 10
                            }} 
                            onClick={() => {
                                // this.setState({ showShareModal: true }, () => {
                                //     setTimeout(() => {
                                        this.updateShare();
                                //     }, 300)
                                // })
                            }}
                        >
                            <IonIcon icon={share} />
                            <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>{(window.ln.shareChanges).replace("__  ", ""/* this.state.pendingCardShareUpdates*/)}</IonLabel>
                        </IonFabButton>
                    }
                </IonFab>
            }
            { (this.state.showGuide) && <ArrowComponent direction="right-bottom" text={window.ln.arrowNewCard} styleLabel={{ width: 120 }} style={{ bottom: 92, left: '50%' }} /> }
             <TagEditorModal
                 currentlyEditedTag={this.state.currentlyEditedTag}
                 onSave={(tag) => { this.saveTag(tag) }}
                 onClose={() => { this.setState({ currentlyEditedTag: null }) }}
             />
             <ExportImportModal
                {...this.props}
                presentingElement={this.pageRef}            
                currentType={this.state.exportImportModal}
                id={(this.state.details ? this.state.details.id : null)}
                tags={this.state.tags}
                onClose={() => {
                    this.setState({ exportImportModal: null, action: "view" });
                    setTimeout(() => {
                        this.load();
                    }, 300)
                }}
                openPrintModal={() => {
                    this.setState({ exportImportModal: null, action: "view", printingModal: true })
                }}
             />
             <PrintingModal
                {...this.props}
                cards={this.state.cards}
                set={this.state.details}
                open={this.state.printingModal}
                presentingElement={this.pageRef}            
                printingModal={this.state.printingModal}
                onClose={() => {
                    this.setState({ printingModal: false  })
                }}
             />
             <IonAlert
                 isOpen={this.state.progressNotSavedAlert}
                 onDidDismiss={() => { this.setState({ progressNotSavedAlert: false }) }}
                 header={window.ln.practiceWithoutSave}
                 message={window.ln.practiceWithoutSaveBody}
                 buttons={[
                    {
                        text: window.ln.saveSetNow,
                        handler: () => {
                            this.downloadSet();
                        }
                     },
                     {
                        text: window.ln.continueWithoutSaveSave,
                        handler: () => { 
                            Utilities.onDrawerShow();
                            this.setState({
                                selectPracticeType: true,
                                selectedPracticeTypeNumber: this.state.filters.length > 0 ? this.state.visibleCards.length : this.state.cards.length,
                                chunkSize: 50
                            })
                        }
                     },
                 ]}
             />
             <IonAlert
                 isOpen={this.state.deleteSetConfirmationAlert}
                 onDidDismiss={() => { this.setState({ deleteSetConfirmationAlert: false }) }}
                 header={window.ln.studysetDeletionH}
                 message={window.ln.studysetDeletionP}
                 buttons={[
                     {
                         text: window.ln.cancel,
                         role: 'cancel',
                     },
                     {
                         text: window.ln.delete,
                         roel: 'delete',
                         handler: () => { this.deleteSet() }
                     }
                 ]}
             />
             <IonAlert
                 isOpen={this.state.deleteCardConfirmationAlert}
                 onDidDismiss={() => { this.setState({ deleteCardConfirmationAlert: false }) }}
                 header={window.ln.cardDeletionH}
                 message={window.ln.cardDeletionP}
                 buttons={[
                     {
                         text: window.ln.cancel,
                         role: 'cancel',
                     },
                     {
                         text: window.ln.delete,
                         roel: 'delete',
                         handler: () => { this.deleteCard(this.state.toBeDeletedCardId) }
                     }
                 ]}
             />
             <IonAlert
                 isOpen={this.state.limitExceededAlert}
                 onDidDismiss={() => { this.setState({ limitExceededAlert: false }) }}
                 header={window.ln.limitExceeded}
                 message={window.ln.cardLimitReached}
                 buttons={[ { text: window.ln.close, role: 'close', }, ]}
             />
             <IonAlert
                 isOpen={this.state.notEnoughAlert}
                 onDidDismiss={() => { this.setState({ notEnoughAlert: false }) }}
                 header={window.ln.notEnoughCards}
                 message={window.ln.atLeastTenCards}
                 buttons={[ { text: window.ln.close, role: 'close', }, ]}
             />
            <IonLoading
                isOpen={this.state.fullscreenLoading && this.state.reviewModal === null}
                message={window.ln.loading}
                duration={2000}
            />
            { (this.state.openCardI !== null) &&
                <FlashcardEditModal
                    onNewTag={(tag) => { this.setState({ tags: [...this.state.tags, tag] }) }}
                    open={this.state.cards[this.state.openCardI].id}
                    flashcard={this.state.cards[this.state.openCardI]}
                    defaultTerm={this.state.details.term || window.ln.term}
                    defaultDefinition={this.state.details.definition || window.ln.def}
                    new={this.state.openCardNew}
                    newOnSave={this.state.cards[this.state.openCardI].notYetSaved}
                    tags={this.state.tags}
                    updateTagReferences={(a, b) => { this.updateTagReferences(a, b) }}
                    onDelete={() => {
                        let visibleCards = this.state.visibleCards;
                        let cards = this.state.cards;
                        cards.splice(this.state.openCardI, 1)
                        visibleCards.splice(this.state.openCardI, 1)
                        this.setState({ cards: cards, visibleCards: visibleCards, openCardI: null, openCardNew: false })
                    }}
                    onClose={ async (changedCard, autoAddNew, addedNewImage) => {
                        if (changedCard) {
                            let visibleCards = this.state.visibleCards;
                            let cards = this.state.cards;
                            changedCard.notYetSaved = false;
                            changedCard.updatedAtTimestamp = Utilities.timestamp();
                            cards[this.state.openCardI] = JSON.parse(JSON.stringify(changedCard))
                            visibleCards[this.state.openCardI] = JSON.parse(JSON.stringify(changedCard))
                            this.setState({ cards: cards, visibleCards: visibleCards }, () => {
                            this.calculatePendingCardShareUpdates();
                            })
                            if (this.state.manualTagFilterRefreshOnSave) {
                                let tagReferences = await SQLStorage.getTagReferencesBySet(this.state.details.id);
                                this.setState({ filters: tagReferences, manualTagFilterRefreshOnSave: false })
                            }
                            if (autoAddNew) {
                                this.addCard();
                            } else {
                                this.setState({ openCardI: null, openCardNew: false })
                            }

                            if (addedNewImage && window.os !== "web" && window.activated) {
                                this.cacheFullsizedImages(true);
                            }
                        } else if (this.state.cards[this.state.openCardI].notYetSaved) {
                            let visibleCards = this.state.visibleCards;
                            let cards = this.state.cards;
                            cards.splice(this.state.openCardI, 1)
                            visibleCards.splice(this.state.openCardI, 1)
                            this.setState({ cards: cards, visibleCards: visibleCards, openCardI: null, openCardNew: false })
                        } else {
                            this.setState({ openCardI: null, openCardNew: false })
                        }
                    }}
                />
            }

            <SwipeableDrawer
                anchor="bottom"
                disableBackdropTransition={false}
                open={this.state.showShareModal}
                onClose={ () => { 
                    this.setState({ showShareModal: false }) 
                    Utilities.onDrawerHide();
                } }
                onOpen={ () => {
                    Utilities.onDrawerShow();
                } }
                className="language-picker-modal sort-picker-modal share-modal"
            >
                { (this.state.details && this.state.cards) &&
                    <div className="swipeable-drawer-body share-modal-body">
                        <div className="drag-indicator"></div>
                        <div className="content">
                            <div className="drag-close-indicator" onClick={() => {
                                this.setState({ showShareModal: false }) 
                                Utilities.onDrawerHide();
                            }}>
                                <IonIcon icon={closeCircle} />
                            </div>
                            { (!this.state.details.owner && this.state.mode !== "preview") &&
                                <React.Fragment>
                                    <h2>{window.ln.share}</h2>
                                    <p style={{ textAlign: 'center' }}>{window.ln.sharingModalIntro}</p>
                                    <img src={ShareImg} />
                                    <div className='share-disclaimer'>
                                        <div>
                                            <IonIcon icon={people} />
                                            <p>
                                                <strong>{window.ln.whatIsShared}: </strong> 
                                                {window.ln.whatIsSharedText}
                                            </p>
                                        </div>
                                        <div>
                                            <IonIcon icon={lockClosed} />
                                            <p>
                                                <strong>{window.ln.whatIsNotShared}: </strong> 
                                                {window.ln.whatIsNotSharedText}
                                            </p>
                                        </div>
                                    </div>
                                    <button className="main" onClick={() => {
                                        this.createShare();
                                    }}>
                                        {window.ln.share}
                                    </button>  
                                </React.Fragment>
                            }
                            { (this.state.details.owner && this.state.mode !== "preview" && ( (window.settings && window.settings.account && window.settings.account.id != this.state.details.owner) || (window.settings && !window.settings.account) )) &&
                                <div>
                                    <h2>{window.ln.checkForSharedUpdates}</h2>
                                    <button className="main" onClick={() => {
                                        this.getShareUpdates();
                                    }}>
                                        {window.ln.fetchUpdates}
                                    </button>
                                </div>
                            }
                            { ( (this.state.details.owner && window.settings && window.settings.account && window.settings.account.id == this.state.details.owner) || this.state.mode === "preview") &&
                                <React.Fragment>
                                    <h2>{this.state.mode === "preview" ? window.ln.share : window.ln.youSharedStudyset}</h2>
                                    <div className='opts'>
                                        <p onClick={ async () => {

                                            if (window.os === "web") {

                                                Clipboard.write({
                                                    string: 'Check out this study set i created at ' + "https://flashcardsmadesimple.com/set/" + this.state.details.viewSecret
                                                });

                                                setTimeout(() => {
                                                    window.toast(window.ln.copied);
                                                }, 200)

                                            } else {

                                                let shareRet = await Share.share({
                                                    title: "Flashcards made Simple",
                                                    text: 'Check out this study set i created at ' + "https://flashcardsmadesimple.com/set/" + this.state.details.viewSecret,
                                                    url: "https://flashcardsmadesimple.com/set/" + this.state.details.viewSecret,
                                                    dialogTitle: 'Check out this study set i created at ' + "https://flashcardsmadesimple.com/set/" + this.state.details.viewSecret,
                                                });

                                            }

                                        }}>
                                            {/* <IonIcon icon={linkSharp} /> */}
                                            { this.state.copied ? window.ln.copied : "flashcardsmadesimple.com/set/" + this.state.details.viewSecret }
                                            <button className='default'>
                                                <div className='icons'>
                                                    <IonIcon icon={logoFacebook} />
                                                    <IonIcon icon={logoTwitter} />
                                                    <IonIcon icon={logoInstagram} />
                                                    <IonIcon icon={logoReddit} />
                                                </div>
                                                <span>{window.ln.shareLink}</span>
                                            </button>
                                        </p>
                                        { (this.state.details.shareMode !== null && this.state.mode !== "preview") &&
                                            <IonItem 
                                                className="long"
                                                style={{
                                                    marginBottom: 15,
                                                    "--padding-start": 0,
                                                    "--border-color": "transparent"
                                                }}
                                            >
                                                <IonLabel>{window.ln.publiclySearchable}</IonLabel>
                                                <IonToggle
                                                    checked={this.state.details.shareMode !== 2}
                                                    onIonChange={(e) => {
                                                        const newShareMode = this.state.details.shareMode !== 2 ? 2 : 1
                                                        let newDetails = JSON.parse(JSON.stringify(this.state.details));
                                                        newDetails.shareMode = null;
                                                        this.setState({ details: newDetails }, () => {
                                                            newDetails.shareMode = newShareMode;
                                                            this.setState({ details: newDetails }, () => {
                                                                this.saveDetails();
                                                            });
                                                        })
                                                        
                                                    }}
                                                />
                                            </IonItem>
                                        }
                                        { (this.state.details.shareMode !== null && this.state.mode !== "preview") &&
                                            <textarea
                                                rows={3}
                                                placeholder={window.ln.description}
                                                value={this.state.details.description || ""}
                                                type="text"
                                                id="term"
                                                onChange={(e) => {
                                                    if (e.keyCode !== 13) {
                                                        this.handleChange("description", e.target.value || "description")
                                                    }
                                                }}
                                                onBlur={() => {
                                                    
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        }
                                    </div>
                                    { this.state.mode !== "preview" &&
                                        <button className="main" onClick={() => {
                                            this.updateShare();
                                        }}>
                                            { window.ln.publishChanges }
                                        </button>
                                    }
                                </React.Fragment>
                            }
                        </div>
                    </div>
                }
            </SwipeableDrawer>
            
            <SwipeableDrawer
                anchor="bottom"
                disableBackdropTransition={false}
                open={this.state.sortPicker}
                onClose={ () => { 
                    this.setState({ sortPicker: false }) 
                    Utilities.onDrawerHide();
                } }
                onOpen={ () => {
                    Utilities.onDrawerShow();
                } }
                className="language-picker-modal sort-picker-modal"
            >
                <div className="swipeable-drawer-body sort-modal-body">
                    <div className="drag-indicator"></div>
                    <div className="content">
                        <h2>{window.ln.selectSortOrder}</h2>
                        <div className="drag-close-indicator" onClick={() => {
                            this.setState({ sortPicker: false }) 
                            Utilities.onDrawerHide();
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        <div className="selector horizontal">
                            <button data-selected={this.state.sortOrder === "ASC"} onClick={() => { this.setState({ sortOrder: "ASC" }) }}>{window.ln.ascSortBy}</button>
                            <button data-selected={this.state.sortOrder === "DESC"} onClick={() => { this.setState({ sortOrder: "DESC" }) }}>{window.ln.descSortBy}</button>
                        </div>
                        <h2>{window.ln.selectSortProp}</h2>
                        <div className="selector vertical">
                            { ["createdAt", "lastReviewed", "reviewCount", "strength", "term", "definition"].map((key, i) => {
                                return (
                                    <button 
                                        key={key} 
                                        onClick={() => { this.setState({ sortBy: key }) }}
                                        data-selected={key === this.state.sortBy}
                                    >{
                                        window.ln[key + "SortBy"]}
                                    </button>
                                )
                            }) }
                        </div>
                        <button className="main" onClick={() => {
                            this.sort();
                            this.setState({ sortPicker: false })
                        }}>{window.ln.applyFilters}</button>
                    </div>
                </div>
            </SwipeableDrawer>

            { (this.state.cards) &&
                <SwipeableDrawer
                    anchor="bottom"
                    open={this.state.selectPracticeType !== null}
                    key="flashcard-editor"
                    transitionDuration={0}
                    className="type-selector"
                    onOpen={ () => {
                        Utilities.onDrawerShow();
                    } }
                    onClose={ () => { 
                        Utilities.onDrawerHide();
                        this.setState({ selectPracticeType: null }) 
                    } }
                >
                    <div data-keyboard-showing={this.state.keyboardShowing} ref={this.modalRef} className="swipeable-drawer-body" className="type-selector-modal" style={{ 
                        position: "absolute",
                        bottom: 0,
                        width: "100%",
                        padding: 15,
                        background: "white",
                        borderRadius: '24px 24px 0 0'
                    }} >
                        <div className="drag-indicator"></div>
                        { (!this.state.allowUninitedPractice) &&
                            <h2 style={{ textAlign: "center", marginBottom: 12, fontSize: '1em', fontWeight: 700 }}>
                                {window.ln.selectPracticeType + ' '}
                                { window.ln.forXYCards.replace("__", (this.state.activeFilters.length !== 0 || this.state.keywords !== "") ? this.state.visibleCards.length : this.state.cards.length). replace("___", "") }
                                {', '}{window.ln.sortHintOther}
                            </h2>
                        }
                        <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            this.setState({ selectPracticeType: null }) 
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        { (this.state.allowUninitedPractice) &&
                            <h2 style={{ textAlign: "center", margin: "5px 0 20px 0", fontWeight: 700 }}>{window.ln.selectPracticeType}</h2>
                        }
                        { (this.state.cards.length > 10 && !this.state.allowUninitedPractice) &&
                            <div className='chunks'>
                                <h3>{window.ln.cardsPerRound}</h3>
                                <IonSegment value={this.state.chunkSize ? this.state.chunkSize.toString() : ""} onIonChange={e => {
                                    this.setState({
                                        chunkSize: parseInt(e.detail.value),
                                    })
                                }}>
                                    <IonSegmentButton value="10">
                                        <IonLabel>10</IonLabel>
                                    </IonSegmentButton>
                                    { (this.state.cards.length >= 20) &&
                                        <IonSegmentButton value="20">
                                            <IonLabel>20</IonLabel>
                                        </IonSegmentButton>
                                    }
                                    { (this.state.cards.length >= 30) &&
                                        <IonSegmentButton value="30">
                                            <IonLabel>30</IonLabel>
                                        </IonSegmentButton>
                                    }
                                    { (this.state.cards.length >= 40) &&
                                        <IonSegmentButton value="40">
                                            <IonLabel>40</IonLabel>
                                        </IonSegmentButton>
                                    }
                                    { (this.state.cards.length >= 50) &&
                                        <IonSegmentButton value="50">
                                            <IonLabel>50</IonLabel>
                                        </IonSegmentButton>
                                    }
                                    {/* <IonSegmentButton value={this.state.selectedPracticeTypeNumber.toString()}>
                                        <IonLabel>All</IonLabel>
                                    </IonSegmentButton> */}
                                </IonSegment>
                            </div>
                        }
                        <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            this.setState({  selectPracticeType: null }) 
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        <div className="activities-wrapper select-type">
                            <div>
                                <div id="flashcards-practice-btn" style={{ backgroundColor: "#1D6AE5" }} data-activity="cards" onClick={ async () => { 
                                    if (this.state.allowUninitedPractice) {
                                        localStorage.setItem("uninitedPractice", JSON.stringify(this.state.cards.slice(0, 50)))
                                        localStorage.setItem("uninitedPracticeUrl", window.location.pathname)
                                    }
                                    this.closeHelpOverlay();
                                    this.setState({ selectPracticeType: null })
                                    if (this.state.visibleCards.length < 1) {
                                        this.setState({ notEnoughAlert: true })
                                    } else {
                                        let pending = await LocalNotifications.getPending();
                                        if (pending.notifications.length !== 0) {
                                            await LocalNotifications.cancel(pending);
                                        }
                                        await Storage.remove("notifications");
                                        if (!this.state.allowUninitedPractice) {
                                            await Utilities.saveCurrentStats();
                                        }
                                        let filters = this.state.activeFilters;
                                        if (this.state.keywords !== "") filters.push("keywords:" + this.state.keywords);
                                        Storage.setO("lastPractice", { uninited: this.state.allowUninitedPractice, type: "flashcards", content: this.props.match.params.id, filters: filters, keywords: this.state.keywords, setName: this.state.details.name, total: this.state.selectedPracticeTypeNumber, chunk: this.state.chunkSize, chunkI: 0 })
                                        this.props.history.push("/flashcards");
                                    }
                                }}>
                                    <img src={FlashcardsImg} />
                                    <div>
                                        <p>
                                            <strong>{window.ln.flashcards}</strong>
                                            {window.ln.flashcardsWhen}
                                        </p>
                                    </div>
                                </div>
                                <div style={{ backgroundColor: "#7536EF" }} data-activity="queue" onClick={ async () => { 
                                    if (this.state.allowUninitedPractice) {
                                        window.toast(window.ln.unsupportedDeviceCache, "error");
                                        return;
                                    }
                                    this.closeHelpOverlay();
                                    this.setState({ selectPracticeType: null })
                                    if (this.state.visibleCards.length < 1) {
                                        this.setState({ notEnoughAlert: true })
                                    } else {
                                        if (!this.state.allowUninitedPractice) {
                                            await Utilities.saveCurrentStats();
                                        }
                                        let filters = this.state.activeFilters;
                                        if (this.state.keywords !== "") filters.push("keywords:" + this.state.keywords);
                                        Storage.setO("lastPractice", { uninited: this.state.allowUninitedPractice, type: "notifications", content: this.props.match.params.id, filters: filters, keywords: this.state.keywords, setName: this.state.details.name, total: this.state.selectedPracticeTypeNumber, chunk: this.state.chunkSize, chunkI: 0 })
                                        this.props.history.push("/queue");
                                    }
                                }}>
                                    <img src={NotificationsImg} />
                                    <div>
                                        <p>
                                            <strong>{window.ln.notifications}</strong>
                                            {window.ln.notificationsWhen}
                                        </p>
                                    </div>
                                </div>
                                <div id="quiz-practice-btn" style={{ backgroundColor: "#2dce91" }} data-activity="practice" onClick={ async () => {
                                    if (this.state.allowUninitedPractice) {
                                        localStorage.setItem("uninitedPractice", JSON.stringify(this.state.cards.slice(0, 50)))
                                        localStorage.setItem("uninitedPracticeUrl", window.location.pathname)
                                    }
                                    this.closeHelpOverlay();
                                    this.setState({ selectPracticeType: null }) 
                                    if (this.state.visibleCards.length < 10) {
                                        this.setState({ notEnoughAlert: true })
                                    } else {
                                        if (!this.state.allowUninitedPractice) {
                                            await Utilities.saveCurrentStats();
                                        }
                                        let filters = this.state.activeFilters;
                                        if (this.state.keywords !== "") filters.push("keywords:" + this.state.keywords);
                                        Storage.setO("lastPractice", { uninited: this.state.allowUninitedPractice, type: "quiz", content: this.props.match.params.id, filters: filters, keywords: this.state.keywords, setName: this.state.details.name, total: this.state.selectedPracticeTypeNumber, chunk: this.state.chunkSize, chunkI: 0 })
                                        this.props.history.push("/practice");
                                    }
                                }}>
                                    <img src={QuizImg} />
                                    <div>
                                        <p>
                                            <strong>{window.ln.quiz}</strong>
                                            {window.ln.quizWhen}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwipeableDrawer>
            }
            <ReviewModal
                {...this.props}
                data={this.state.reviewModal}
                onClose={() => {
                    this.setState({ reviewModal: null })
                }}
            />
            <div className="nonblocking-loading-wrapper" style={(this.state.nonBlockingLoading) ? { display: 'flex' } : { display: 'none' }}>
                <div
                    className="loading-spinner-own"
                    style={{
                        marginRight: 8
                    }}
                />
                {this.state.nonBlockingLoading}
            </div>
          </IonPage>
        );
    }

};


export default withIonLifeCycle(Studyset);
